<div id="pause" class="d-flex align-items-center justify-content-center" *ngIf="isLoading.value"> 
    <div>
        <div class="spinner">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
        </div>
        <h6 class="mt-2 text-center" style="color: white; z-index: 888888888; ">Loading</h6>
    </div> 
</div>
